export const ADSK_STABLE_VERSION = '7.117';
